module.exports = __webpack_public_path__ + "img/cancel.290fa064.svg";